<template>
  <q-page padding>
    <div class="card q-pa-md text-brand-5 text-weight-bold">
      <div class="row col-12 topo q-mb-sm">
        <div style="width: 18%" class="column justify-around top">
          <q-img
            v-if="dadosDescricao.url_logo"
            :src="dadosDescricao.url_logo"
          />
          <q-img v-else src="../../../assets/MULTPEX_VETOR.png" />
        </div>
        <div class="text-h6 master-title">Relatório de Movimentos de EPI</div>
      </div>
      <span v-if="dadosDescricao" v-html="dadosDescricao.cabecalho"></span>
      <div class="col-12 q-mt-md">
        <q-table
          :columns="columnsUsuario"
          :rows="dadosFichaUsuario"
          hide-bottom
          dense
          class="my-sticky-header-table"
          table-header-class="bg-white text-black text-weight-bold"
          flat
        >
          <template v-slot:body-cell-empresa="props">
            <q-td class="text-weight-bold" :props="props">
              <span>{{ $store.state.autenticacao.cliente[0] }}</span>
            </q-td>
          </template>
        </q-table>

        <q-table
          :columns="columnsTabela"
          :rows="dadosFichaEpi"
          :rows-per-page-options="[0]"
          style="margin-bottom: 80px"
          dense
          table-header-class="bg-white text-black text-weight-bold"
          flat
          hide-bottom
          class="my-sticky-header-table q-mt-md"
        >
          <template v-slot:body-cell-EntregueEm="props">
            <q-td class="text-brand-5 text-weight-bold" :props="props">
              <span v-if="props.row.RetiradoPorData">{{
                props.row.RetiradoPorData.split(" ")[0]
                  .split("-")
                  .reverse()
                  .join("/")
              }}</span>
            </q-td>
          </template>

          <template v-slot:body-cell-autenticacaoCriacao="props">
            <q-td class="text-brand-5 text-weight-bold" :props="props">
              <span
                v-if="
                  props.row.AprovacaoAutenticacaoTipo != 'biometria' &&
                  props.row.AprovacaoAutenticacaoTipo != 'assinatura' &&
                  props.row.AprovacaoAutenticacaoTipo != 'facial'
                "
                >Assinado eletronicamente</span
              >
              <span v-else>
                <q-img
                  :src="props.row.AprovacaoAutenticacao"
                  style="max-width: 300px; height: 70px"
                  fit="contain"
                >
                </q-img
              ></span>
            </q-td>
          </template>
          <template v-slot:body-cell-autenticacaoFinalizacao="props">
            <q-td class="text-brand-5 text-weight-bold" :props="props">
              <span
                v-if="
                  props.row.FinalizacaoAutenticacaoTipo != 'biometria' &&
                  props.row.FinalizacaoAutenticacaoTipo != 'assinatura' &&
                  props.row.FinalizacaoAutenticacaoTipo != 'facial'
                "
                >Assinado eletronicamente</span
              >
              <span v-else>
                <q-img
                  :src="props.row.FinalizacaoAutenticacao"
                  style="max-width: 300px; height: 70px"
                  fit="contain"
                >
                </q-img
              ></span>
            </q-td>
          </template>
        </q-table>

        <div class="assinatura">
          <span
            >Eu,
            <span v-if="dadosFichaUsuario">{{
              dadosFichaUsuario[0]?.nomeEmpregado
            }}</span>
            reconheço que recebi os materiais acima descritos nas datas acima
            indicadas</span
          >
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
import { ref, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";

export default {
  setup() {
    const route = useRoute();
    const store = useStore();
    const quasar = useQuasar();
    const pdtDawnload = ref(0);
    const columnsUsuario = ref([
      {
        name: "name",
        label: "Nome Funcionário",
        align: "left",
        field: (row) => row.nomeEmpregado,
      },
      {
        name: "sap",
        label: "Matricula Funcionário",
        align: "left",
        field: (row) => row.matricula,
      },
      {
        name: "centro",
        label: "Centro de custo",
        align: "left",
        field: (row) => row.centroDeCusto,
      },
      {
        name: "cargo",
        label: "Função",
        align: "left",
        field: (row) => row.funcao,
      },
      {
        name: "dataDemissao",
        label: "Admissão",
        align: "left",
        field: (row) => row?.dataAdmissao.split("-").reverse().join("/"),
      },
      {
        name: "empresa",
        label: "Empresa",
        align: "left",
        field: "empresa",
      },
    ]);
    const columnsTabela = ref([
      {
        name: "EntregaUnidadeNome",
        label: "Codigo Material",
        align: "left",
        field: (row) => row.codigoMaterial,
        style: "white-space: normal",
      },
      {
        name: "SolicitanteFuncao",
        label: "Descrição Material",
        align: "left",
        field: (row) => row.descricaoMaterial,
        style: "white-space: normal",
      },
      {
        name: "CentroCustoCodigo",
        label: "C.A",
        align: "left",
        field: (row) => row.ca,
        style: "white-space: normal",
      },

      {
        name: "CentroCustoNome",
        label: "Quantidade",
        align: "left",
        field: (row) => Number(row?.quantidade).toFixed(2),
        style: "white-space: normal",
      },
      {
        name: "CentroCustoResponsavel",
        label: "Data Entrega",
        align: "left",
        field: (row) => row?.dataEntrega?.split("-")?.reverse()?.join("/"),
        style: "white-space: normal",
      },
    ]);
    const dadosDescricao = ref("");
    let unidade = ref({
      nome: store.state.org.unidadeData,
      id: store.state.org.unidadeData.id,
    });

    const params = ref({
      matricula: route.params.id,
    });
    const fichaEpiTextos = ref({
      titulo: "",
      dizeres: "",
    });

    const columnsAtivas = ref([]);
    const dadosFichaEpi = ref([]);

    const dadosFichaUsuario = ref([]);

    const listarDadosFichaEpi = async () => {
      quasar.loading.show();

      store.dispatch("pdt/hiddenHeader", false);
      const response = await store.dispatch("seguranca/getFichaLegado", {
        matricula: params.value.matricula,
        nome_relatorio: "epi_legado_vale",
        per_page: 9999,
      });

      dadosFichaEpi.value = await response.data.dados;
      dadosFichaUsuario.value.push(response.data.dados[0]);
      quasar.loading.hide();
      setTimeout(() => {
        window.print();
      }, 3000);
    };

    onMounted(listarDadosFichaEpi);

    const listarDescricao = async () => {
      const response = await store.dispatch("seguranca/getDescricao", {
        vendor_id: await store.state.org.unidadeData.id,
      });

      dadosDescricao.value = response.data.response;
    };

    onMounted(listarDescricao);

    watch(
      () => store.state.org.unidadeData,
      () => {
        unidade.value.nome = store.state.org.unidadeData;
        unidade.value.id = store.state.org.unidadeData.id;
      }
    );

    return {
      columnsUsuario,
      columnsTabela,
      listarDadosFichaEpi,
      params,
      fichaEpiTextos,
      columnsAtivas,
      dadosFichaEpi,
      dadosFichaUsuario,

      dadosDescricao,
      pdtDawnload,
    };
  },
};
</script>

<style lang="sass">
@page
  size: A4 landscape


.topo
  align-items: center

.topo .master-title
  margin: 0 auto
  color: #000
  font-weight: bold

.assinatura
  border-top: 2px solid black
  width: 690px
  color: black
  margin:0 auto

@media print
  .q-table__middle
    overflow: unset !important

  .my-sticky-header-table
    /* height or max-height is important */

    .q-table__top,
    .q-table__bottom,
    thead tr:first-child th
      /* bg color is important for th; just specify one */

    thead tr th
      font-size: 11px
    tbody tr td
      font-size: 10px
      white-space: pre-wrap
    thead tr:first-child th
      top: 0

    /* this is when the loading indicator appears */
    &.q-table--loading thead tr:last-child th
      /* height of all previous header rows */
      top: 48px
</style>
